import { DropdownList, DropdownItem, Dropdown } from '@cokitchen/cokitchen-components';
import React, { useState } from 'react';
import { ReactComponent as SortIcon } from 'assets/icons/sort.svg';

type Props = {
  text?: string;
  options: { name: string }[];
  filterValue?: string;
  setFilterValue?: (value: string) => void;
};
const SortInput = ({ options, filterValue, setFilterValue, text = 'Sort by' }: Props) => {
  const [showDropdown, setShowDropdown] = useState(false);
  return (
    <div className='w-full max-w-[85vw] sm:max-w-fit'>
      <Dropdown
        visible={showDropdown}
        onClickOutside={() => setShowDropdown(false)}
        content={
          <button
            className='flex justify-between items-center min-w-[150px] border border-[#E5E6E6] rounded-md p-2 text-[#5E6164] text-sm gap-2 cursor-pointer h-[36px] w-full'
            onClick={() => setShowDropdown(!showDropdown)}>
            <p className='  gap-3 pl-2  text-sm text-[#5E6164]'>{filterValue || text}</p>
            <SortIcon />
          </button>
        }>
        <DropdownList>
          {options.map(({ name }: { name: string }, index) => (
            <DropdownItem
              key={index}
              onClick={() => {
                setFilterValue?.(name);
                setShowDropdown(false);
              }}
              className='text-sm font-light object-fit  hover:bg-gray-400 cursor-pointer'
              buttonClassName='py-2'>
              <div className=''>{name}</div>
            </DropdownItem>
          ))}
        </DropdownList>
      </Dropdown>
    </div>
  );
};

export default SortInput;
